export default "__VITE_ASSET__wfh8rRgp__"